<div class="institution-container">
    	<app-admin-header [pageTitle]="tenantName" [pageSubTitle]="tenantSubName"></app-admin-header>
    <div class="teacher-management-container">
        <mat-card class="institution-card">
            <h3 class="section-title">Institution Details</h3>

            <form [formGroup]="institutionForm" class="form-grid">
                <div class="form-field">
                    <label>Institution Name</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="name"  readonly/>
                    </mat-form-field>
                </div>
                <div class="form-field">
                    <label>Domain</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="domain" readonly />
                    </mat-form-field>
                </div>
                <!-- <div class="form-field">
                    <label>Institution Type</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="type">
                            <mat-option value="Engineering College">Engineering College</mat-option>
                            <mat-option value="University">University</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div> -->
                <!-- <div class="form-field">
                    <label>Academic Format</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="format">
                            <mat-option value="Semester">Semester</mat-option>
                            <mat-option value="Trimester">Trimester</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div> -->
                <div class="form-field">
                    <label>Contact Email</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="email" readonly/>
                    </mat-form-field>
                </div>
                <!-- <div class="form-field">
                    <label>Institution Logo</label>
                    <div class="upload-box" (click)="fileInput.click()">
                        <mat-icon>upload</mat-icon>
                        <span>Upload Logo</span>
                        <input type="file" #fileInput hidden (change)="onLogoUpload($event)" />
                    </div>
                </div> -->
                <!-- <div class="form-field full-width">
                    <label>Address</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <textarea matInput rows="2" formControlName="address"></textarea>
                    </mat-form-field>
                </div> -->
                <!-- <div class="button-group">
                    <div class="left-buttons">
                        <button mat-flat-button color="primary" (click)="saveChanges()">Save Changes</button>
                        <button mat-stroked-button (click)="editProfile()">Edit Profile</button>
                    </div>
                    <div class="right-buttons">
                        <button mat-flat-button color="warn" (click)="deactivateInstitution()">Deactivate
                            Institution</button>
                    </div>
                </div> -->
            </form>
        </mat-card>
    </div>
</div>